<template>
  <b-server-table
    :key="renderKey"
    :filter-props="{
      filterMap: [
        { key: 'search' },
        {
          key: 'departmentId',
          directory: 'departmentList',
          component: 'select',
        },
        {
          key: 'roleId',
          directory: 'roles',
          component: 'select',
        },
        {
          key: 'isActive',
          component: 'checkbox',
        },
      ],
    }"
    :headers="columns"
    :request-func="userList"
    @click:row="openRow">
    <template #bottom></template>
    <template #item.isActive="{ item }">
      {{ item.isActive ? 'Активний' : 'Звільнений' }}
    </template>
    <template #item.department="{ item }">
      {{ item.department?.name || '---' }}
    </template>
    <template #item.name="{ item }">
      {{ getPersonName(item) || '---' }}
    </template>
  </b-server-table>
</template>

<script>
import { useStore } from 'vuex'
import { ref } from 'vue'
import { BServerTable } from 'best-modules/components'
import { getPersonName } from 'best-modules/utils'
import { userList } from '@/requests/user'
import { openUserCardDialog } from '@/utils/userCardDialog'

export default {
  name: 'UserList',
  components: {
    BServerTable,
  },
  methods: { userList, getPersonName },
  setup() {
    const renderKey = ref(1)
    const store = useStore()
    const columns = ref([
      {
        key: 'isActive',
        title: 'Статус',
      },
      {
        key: 'name',
        title: 'ПІБ',
        width: 250,
      },
      {
        key: 'department',
        title: 'Департамент',
      },
      { key: 'post', title: 'Посада' },
    ])

    const openRow = event => {
      openUserCardDialog({
        userId: event.id,
        mode: 'employee',
        context: 'list',
        title: getPersonName(event),
        cb: () => {
          renderKey.value += 1
        },
      })
    }

    return {
      store,
      openRow,
      columns,
      renderKey,
    }
  },
}
</script>
